"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var couponNormalizer = function (response, country) {
    var data = response.data;
    if (!data || !(data.units > 0)) {
        return __assign(__assign({}, response), { data: null });
    }
    var getUrlFromAssetKey = function (key) { return data.assets[key]; };
    var getApplicableSkus = function (skus) {
        if (!skus)
            return null;
        var formattedSkus = {};
        skus &&
            Object.keys(skus).forEach(function (skuKey) {
                var sku = skus[skuKey];
                formattedSkus[skuKey] = {
                    enabled: sku.enabled,
                    percentOff: sku.percent_off,
                    badges: sku.badges &&
                        sku.badges.map(function (badge) { return ({
                            country: badge.country,
                            lang: badge.lang,
                            url: getUrlFromAssetKey(badge.key),
                            default: badge.default,
                        }); }),
                };
            });
        return formattedSkus;
    };
    var getBanners = function (banners) {
        if (!banners || !Object.keys(banners).length)
            return null;
        var formattedBanners = {
            default: null,
            tablet: null,
            mobile: null,
        };
        Object.keys(banners).forEach(function (key) {
            var bannerType = banners[key];
            formattedBanners[key] = bannerType.map(function (banner) { return ({
                backgroundImage: getUrlFromAssetKey(banner.background_image),
                url: getUrlFromAssetKey(banner.content_image) || '',
                backgroundColor: banner.background_color,
                default: !!banner.default,
                country: banner.country,
                lang: banner.lang,
            }); });
        });
        return formattedBanners;
    };
    var getHeaderBanner = function (data) {
        var hide_on_shopping_tabs = data.hide_on_shopping_tab || data.hide_on_shopping_tabs;
        var formattedHeaderBanner = {
            images: getBanners(data.images),
            showOnPages: typeof data.show_on_pages === 'string'
                ? [data.show_on_pages]
                : data.show_on_pages,
            hideOnPages: data.hide_on_pages,
            hideOnShoppingTabs: typeof hide_on_shopping_tabs === 'string'
                ? [hide_on_shopping_tabs]
                : hide_on_shopping_tabs,
            linkTo: data.link_to,
        };
        return formattedHeaderBanner;
    };
    var getContent = function (data) {
        var _a, _b, _c, _d, _e, _f;
        return {
            featuredSections: {
                heading: {
                    default: (_b = (_a = data.featured_sections) === null || _a === void 0 ? void 0 : _a.heading) === null || _b === void 0 ? void 0 : _b.default,
                },
                skus: (_c = data.featured_sections) === null || _c === void 0 ? void 0 : _c.skus,
                hideExistingFeaturedSections: (_d = data.featured_sections) === null || _d === void 0 ? void 0 : _d.hide_existing_featured_sections,
                subsections: (_f = (_e = data.featured_sections) === null || _e === void 0 ? void 0 : _e.subsections) === null || _f === void 0 ? void 0 : _f.map(function (subsection) {
                    var _a;
                    return ({
                        heading: {
                            default: (_a = subsection === null || subsection === void 0 ? void 0 : subsection.heading) === null || _a === void 0 ? void 0 : _a.default,
                        },
                        skus: subsection === null || subsection === void 0 ? void 0 : subsection.skus,
                    });
                }),
            },
        };
    };
    return __assign(__assign({}, response), { data: {
            country: country,
            countries: data.countries,
            code: data.id || data.coupon_code,
            isGlobal: data.is_default,
            campaign: data.campaign,
            type: data.type,
            applicableSkus: getApplicableSkus(data.discounted_skus),
            discountAmount: data.discount_amount,
            percentOff: data.percent_off,
            discountOriginalPrice: data.discount_original_price,
            remainingUnits: data.units,
            skuQuantityLimit: data.sku_quantity_limit,
            status: data.status,
            bonusSkus: (data.bonus_skus && Object.keys(data.bonus_skus)) || [],
            triggerSkus: data.trigger_skus,
            expireDate: data.expires_on || null,
            featuredBanner: (data.banners && getBanners(data.banners.featured)) || null,
            header: (data.banners && getHeaderBanner(data.banners.header)) || null,
            content: (data.content && getContent(data.content)) || null,
        } });
};
exports.default = couponNormalizer;
